define('controllers/admin/customers',['require','nicEditlatest','johngrid','hotkeys'],function (require) {
    require('nicEditlatest');
    var CreateJohnGrid = require('johngrid');
    require('hotkeys');

    return function() {
        var columns = [
                            { DataField: "ContactsLink", HeaderText: "", AllowSorting: false },
                            { DataField: "Name_Full", HeaderText: "Name" },
                            { DataField: "ShortURL", SortField: "ShortUrlID" },
                            { DataField: "CustomerType", AllowSorting: false },
                            { DataField: "MailingAddress" },
                            { DataField: "Comments" },
                            { DataField: "Inactive" },
                            { DataField: "CreateDate", HeaderText: "Created" }
        ],
                dataSource = 'customersAJAX.aspx',
                table = $("#tblCustomers"),
                saveTemplate = $("#editForm"),
                txtSearch = $("#txtSearch"),
                txtBrandingHtmlID = "txtBrandingHtml",
                txtBrandingHtml = new nicEditor({ fullPanel: true }).panelInstance(txtBrandingHtmlID, { hasPanel: true }),
                gridLimit = 20,
                grid = CreateJohnGrid();

        grid.insertHelpers.init(saveTemplate);
        grid.insertHelpers.onAdd = function () {
            txtBrandingHtml.instanceById(txtBrandingHtmlID).setContent("");
        };
        grid.deleteHelpers.allowDelete = true;
        grid.sorting.allowSorting = true;
        grid.dsPostValues.sortClause = "CreateDate DESC";
        grid.editHelpers.init(saveTemplate);
        grid.editHelpers.onEdit = function (item) {
            if (item.Inactive != "") {
                $("#InactiveDate").text(item.Inactive);
                $("input[name='Inactive']").prop('checked', true);
            } else {
                $("#chkInactive").prop('checked', false);
                $("#InactiveDate").text("");
            }

            //set up branding wysiwyg
            txtBrandingHtml.instanceById(txtBrandingHtmlID).setContent(item.BrandingHtml);
        };
        grid.utilities.validateItem = function (item) {
            var errors = [];

            if (item.Name_Full.trim().length == 0) {
                errors.push("-Please enter a name.");
            }
            if (item.Lead.trim().length == 0) {
                errors.push("-Please enter a lead.");
            }
            if (item.CustomerTypeID == undefined) {
                errors.push("-Please choose a customer type");
            }

            item.BrandingHtml = Utilities.htmlEncode(txtBrandingHtml.instanceById(txtBrandingHtmlID).getContent());
            return errors;
        };
        grid.init(table, columns, dataSource);

        $(".johnGridHeader", grid.$table).prepend($("#headerTemplate")); //consider adding $headerTemplate to JohnGrid...

        grid.dsPostValues.take = gridLimit;
        bindCustomers();
        var t = null;
        txtSearch.on("keyup", function () {
            if (t != null) {
                clearTimeout(t);
            }
            t = setTimeout(bindCustomers, 250); //limit to 1 hit per half second
        });
        function bindCustomers() {
            grid.dsPostValues.term = txtSearch.val();
            grid.databind();
        }

        //$('#ctl00_ctl00_MainClump_CPHMain_btnUploadCustomerImage').on('click', function() {
        //TODO: encode or clear html stuff to avoid errors...
        //});

        txtSearch.focus();
        $(document).on('keyup', null, 's', function () {
            txtSearch.focus();
        });
    };
});

